import { useState, useEffect } from 'react';
import { basePort, queryParameters, getUsernameJwt, headers, getRoleJwt, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies, IsMbrRolePv } from "../../module_auth/AuthService"
import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../common/Toast"

export function CmtyBaseEditPost() {
    const navigate = useNavigate();
    const queryParameters = new URLSearchParams(window.location.search)
    const cmtyPostId = queryParameters.get("id")
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [mbrId, setMbrId] = useState("");

    const [jwtToken, setJwtToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");

    const [cmtyCatgName, setCmtyCatgName] = useState(localStorage.getItem("CTMY_CATG_NAME"));
    const [cmtyCatgUrl, setCmtyCatgUrl] = useState(localStorage.getItem("CTMY_CATG_URL"));

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        if(getJwtFromCookies() == null 
            || isExpiredJwt(getJwtFromCookies())
            || getRoleJwt(getJwtFromCookies()) != "ROLE_PV"){
            moveTo()
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            loadCmtyPost()
        }
    }, []);

    function loadCmtyPost(){
        let url = basePort + '/get/cmty/post/' + cmtyPostId
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setTitle(response.title)
                setContent(response.content)
            }).catch(error => console.log(error))
    }

    function clickSubmit(event) {
        event.preventDefault();
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/update/cmty/post', 
            {method:'post', headers,
                        body:JSON.stringify({
                        title:title,
                        content:content,
                        cmtyPostId:cmtyPostId
                    })})
                    .then(response => response.json())
                    .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function moveTo() {
        setRedirectUrl("/cmty_base_post?id="+cmtyPostId);
        setRedirect(true)
    }

    function handleTitle(event) {
        setTitle(event.target.value);
    }

    function handleImage(){
        //nothing
    }

    return (
        <div>
            {renderRedirect(redirect, redirectUrl)}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><span>커뮤니티</span></li>
                        <li class="breadcrumb-item"><span>{cmtyCatgName}</span></li>
                        <li class="breadcrumb-item"><span>글쓰기</span></li>
                        <li class="breadcrumb-item"><span>수정</span></li>
                    </ol>
                    <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                        <input class="form-control" type="text" value={title} onChange={handleTitle}/>
                    </form>
                    <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                        <label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>내용</label>
                        <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                        <ReactQuill theme="snow" value={content} onChange={setContent}
                            style={{height: '300px', marginBottom:'10px'}}
                            modules={{
                                toolbar: {
                                    container: [
                                        [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                        [{ size: [] }],
                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['image'],
                                        ['clean'],
                                        ['code-block']
                                    ],
                                    handlers: {
                                        image: handleImage(),
                                    },
                                },
                            }}
                        />
                        </div>
                    </form>
                    <form style={{textAlign: 'center', marginBottom: '10px', marginTop: '10px'}}>
                        <button class="btn btn-secondary" type="button" onClick={moveTo} style={{marginRight: '5px'}}>취소하기</button>
                        <button class="btn btn-primary" type="button" onClick={clickSubmit}>등록하기</button>
                    </form>
                    <ToastMessage show={showToast} msg={msgToast}/>
                    </div>
                </section>
            </main>
        </div>
    );
}